import {
    GenericItemsUtils,
    IGetAllParams,
    GenericItemsForm,
    BaseGenericItemsStore,
    MuiDataGrid,
    MuiIcons,
    useTheme
} from "@leap4/frontend";

import {IAdServerTag} from "@leap4/entities-discrepancy-common"
import {AdServerTagsBaseUrl} from "../../../../config/generals";
import {urlService} from "../../../routing/urlsService";
import {Link} from "react-router-dom"
import {RootState} from "../../../../interfaces/root-state.interface";
import {connect, ConnectedProps} from "react-redux";

type GridColDef = MuiDataGrid.GridColDef;
type GridRenderCellParams = MuiDataGrid.GridRenderCellParams;
const {Tag: TagIcon} = MuiIcons;

const fields = {
    name: 1,
    dataPoint: 1,
    campaignId: 1,
    side: 1,
    companyId: 1,
    publisherTag: 1
}

const populate = [{path: "dataPoint", select: {name: 1}}, {path:"publisherTag", select: {name: 1}}];

const getParams: IGetAllParams = {
    fields,
    populate
}

let columns: GridColDef[];
let store: BaseGenericItemsStore<IAdServerTag & { _id: string, isActive: boolean }>

function setStoreAndColumns(theme) {
    const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
        baseUrl: `${AdServerTagsBaseUrl}`
    }, fields, {
        name: {editLinkFunc: (id: string) => urlService.adServerTag(id, true)},
        isActive: {},
        updated: {},
        created: {},

    })

    store = storeAndColumns.store;
    columns = storeAndColumns.columns;

    const dataPointCol = columns.find(x=> x.field === "dataPoint");
    dataPointCol.renderCell = (params: GridRenderCellParams) =>
        <Link to={urlService.adServerTag((params.value as any)._id, true)}><strong style={{color: theme.palette.text.primary}} >{(params.value as any).name}</strong></Link>
    dataPointCol.valueFormatter = (value: any) => value?.name || 'Un-Named'
    const publisherTagCol = columns.find(x=> x.field === "publisherTag");
    publisherTagCol.renderCell = (params: GridRenderCellParams) => params.value ?
        <Link to={urlService.publisherTag((params.value as any)._id, true)}>
            <strong
            >{(params.value as any).name}</strong></Link>: ""
    publisherTagCol.valueFormatter = (value: any) => value?.name || 'Un-Named'
}
const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});


const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
const AdServerTagsDashboardModule = (props:PropsFromRedux) => {
    const theme = useTheme()
    setStoreAndColumns(theme);

    return (
            <GenericItemsForm
                organization={props.selectedOrganization}
                columns={columns}
                store={store}
                breadcrumbs={{
                    link: urlService.adServerTags(),
                    text: "Ad Server Tags Dashboard",
                    icon: <TagIcon />
                }}
                tableProps={{pageSize: 100, style: {minHeight: "75vh"}}}
                getAllParams={getParams}
            />
    );
};


export default connector(AdServerTagsDashboardModule);